export default __webpack_public_path__ + "static/media/lowes.348ab91c.png";